import type { IFluidContainer } from 'fluid-framework';
import React from 'react';

/**
 * Represents a React Context that includes a Fluid container.
 */
export const FluidContainerContext = React.createContext<IFluidContainer | undefined>(undefined);
